import { FilterOutlined, SwapRightOutlined } from '@ant-design/icons';
import { Button, Col, DatePicker, Input, Row, Select, Space } from 'antd';
import type { Dayjs } from 'dayjs';

type FilterOption = {
  label: string;
  value: string;
};

type IncidenceApprovalFiltersProps = {
  folioFilter: string;
  requesterFilter: string;
  incidenceTypeOptions: FilterOption[];
  statusOptions: FilterOption[];
  incidenceTypeFilter?: string;
  statusFilter?: string;
  fromDateFilter: Dayjs | null;
  toDateFilter: Dayjs | null;
  onFolioFilterChange: (value: string) => void;
  onRequesterFilterChange: (value: string) => void;
  onIncidenceTypeFilterChange: (value?: string) => void;
  onStatusFilterChange: (value?: string) => void;
  onFromDateFilterChange: (value: Dayjs | null) => void;
  onToDateFilterChange: (value: Dayjs | null) => void;
  onClearFilters: () => void;
};

export const IncidenceApprovalFilters = ({
  folioFilter,
  requesterFilter,
  incidenceTypeOptions,
  statusOptions,
  incidenceTypeFilter,
  statusFilter,
  fromDateFilter,
  toDateFilter,
  onFolioFilterChange,
  onRequesterFilterChange,
  onIncidenceTypeFilterChange,
  onStatusFilterChange,
  onFromDateFilterChange,
  onToDateFilterChange,
  onClearFilters,
}: IncidenceApprovalFiltersProps) => {
  const dateRangeValue: [Dayjs, Dayjs] | null =
    fromDateFilter && toDateFilter ? [fromDateFilter, toDateFilter] : null;

  return (
    <Row
      className="employee-incidence-filters employee-incidence-filters--desktop mt-5 mb-5"
      align="middle"
      justify="space-between"
      gutter={[12, 12]}
    >
      <Col flex="auto">
        <Space size={8} wrap>
          <FilterOutlined className="filter-icon" />
          <Input
            allowClear
            value={folioFilter}
            className="filter-control filter-text-control filter-text-control--folio"
            placeholder="Folio"
            onChange={(event) => onFolioFilterChange(event.target.value)}
            data-cy="approval-request-folio-filter"
          />
          <Input
            allowClear
            value={requesterFilter}
            className="filter-control filter-text-control filter-text-control--requester"
            placeholder="ID, nombre o correo de empleado"
            onChange={(event) => onRequesterFilterChange(event.target.value)}
            data-cy="approval-request-requester-filter"
          />
          <Select
            allowClear
            className="filter-control"
            placeholder="Tipo de incidencia"
            options={incidenceTypeOptions}
            value={incidenceTypeFilter}
            onChange={onIncidenceTypeFilterChange}
            data-cy="approval-request-type-filter"
          />
          <DatePicker.RangePicker
            className="filter-control filter-range-control"
            placeholder={['Fecha inicial', 'Fecha final']}
            separator={<SwapRightOutlined />}
            value={dateRangeValue}
            onChange={(value) => {
              onFromDateFilterChange(value?.[0] ?? null);
              onToDateFilterChange(value?.[1] ?? null);
            }}
            data-cy="approval-request-date-filter"
          />
          <Select
            allowClear
            className="filter-control"
            placeholder="Status"
            options={statusOptions}
            value={statusFilter}
            onChange={onStatusFilterChange}
            data-cy="approval-request-status-filter"
          />
          <Button
            type="link"
            onClick={onClearFilters}
            className="clean-filters-text"
            data-cy="approval-request-clear-filters-btn"
          >
            Limpiar filtros
          </Button>
        </Space>
      </Col>
    </Row>
  );
};
